import {AnyAction, combineReducers} from 'redux';
import {isSetRowsPerPage} from './actions';
import {Preferences} from './state';

export const INITIAL_STATE: Preferences = {
  rowsPerPage: 5
};

export const preferences = combineReducers({
  rowsPerPage
});

function rowsPerPage(state = INITIAL_STATE.rowsPerPage, action: AnyAction) {
  if (isSetRowsPerPage(action)) {
    return action.rowsPerPage;
  }

  return state;
}
